let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2bK0D")).then(() => parcelRequire('6GRhK'));